module.exports = __webpack_public_path__ + "static/media/poweredBy.408c03cd.svg";